import React, { useState, useEffect } from 'react';
import { Segment } from 'semantic-ui-react';

const MovingText = ({ texts }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 20000); // Change text every 10 seconds

    return () => clearInterval(interval);
  }, [texts.length]);

  const handleClick = () => {
    if (typeof gtag === "function")
      gtag('event', 'scrollingText', { 'event_category': 'sales', 'event_label': "Save" });
    window.open("https://dcaclab.com/en/pricing-table", "_blank");
  };

  return (
    <Segment className="scrolling-text-container" style={{borderColor: 'transparent',  backgroundColor: 'transparent'}} >
      <div className="scrolling-text" style={{cursor: 'pointer',fontSize: 15, top: -1, color: 'white'}} onClick={handleClick}>
        {texts[currentTextIndex]}
      </div>
    </Segment>
  );
};

export default MovingText;
